
 let dataP = window.productVariants;
 let widgetType = window.widget_type;
 console.log("widgetType --->", widgetType);

  document.addEventListener('DOMContentLoaded', function () {
  
  
  const LOCAL_STORAGE_MAKE_MODEL_KEY = "makeModel";
  function clearLocalStorage() {
    window.localStorage.removeItem(LOCAL_STORAGE_MAKE_MODEL_KEY);
  }

  function pageInit() {
    clearLocalStorage();
  }
  pageInit();

  const thumbs = new Swiper("div[data-swiper='img-gallery-thumb']", {
    slidesPerView: 5,
    spaceBetween: 10,
    loop: true,
    breakpoints: {
      960: { slidesPerView: 6 },
      1200: { slidesPerView: 8 },
    },
  });
  const imgGallerySwiper = new Swiper("div[data-swiper='img-gallery']", {
    spaceBetween: 10,
    thumbs: {
      swiper: thumbs,
    },
    loop: true,
  });

  const progressBar = document.querySelector(
    ".why-trc--slider-progress-bar .progress-bar-inner"
  );
  const whyTrcSlider = new Swiper(".why-trc-slider", {
    freeMode: {
      momentum: false,
      enabled: true,
    },
    spaceBetween: 10,
    slidesPerView: 1,
    breakpoints: {
      576: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      768: { slidesPerView: 3, spaceBetween: 20 },
      960: { slidesPerView: 4, spaceBetween: 20 },
    },
    on: {
      progress: (swiper, progress) => {
        const percentage = parseFloat(progress * 100);
        let targetPercentage = 0;
        if (percentage > 100) targetPercentage = 100;
        else if (percentage < 0) targetPercentage = 0;
        else targetPercentage = percentage;
        progressBar.style.width = `${targetPercentage}%`;
      },
    },
  });

  const shareButton = document.querySelector(".pp-share--button");
  shareButton.addEventListener("click", () => {
    const { shareTitle } = shareButton.dataset;
    navigator.share({
      title: shareTitle,
      text: shareTitle,
      url: window.location.href,
    });
  });

  const faqTitles = document.querySelectorAll(".pp-faq--question-container");

  function closeOtherRows(currentRow) {
    faqTitles.forEach((item, j) => {
      if (Math.floor(j / 2) !== currentRow) {
        const content = item.nextElementSibling;
        const paragraph = content.querySelector("p");
        const itemIndicator = item.querySelector(".pp-faq--question-indicator");
        if (content.classList.contains("opened")) {
          paragraph.style.maxHeight = null;
          content.classList.remove("opened");
          itemIndicator.innerText = "+";
        }
      }
    });
  }
  function toggleFaq(el) {
    const contentContainer = el.nextElementSibling;
    const paragraph = contentContainer.querySelector("p");
    const indicator = el.querySelector(".pp-faq--question-indicator");
    const isOpened = contentContainer.classList.contains("opened");

    if (isOpened) {
      paragraph.style.maxHeight = null;
      contentContainer.classList.remove("opened");
      indicator.innerText = "+";
    } else {
      paragraph.style.maxHeight = paragraph.scrollHeight + "px";
      contentContainer.classList.add("opened");
      indicator.innerText = "-";
    }
  }

  faqTitles.forEach((el, i) => {
    el.addEventListener("click", () => {
      const currentRow = Math.floor(i / 2);
      closeOtherRows(currentRow);
      toggleFaq(el);
    });
  });


  // ----------- Fixed btn & Variant add to cart -------------
  const bottomDivider = document.querySelector(".pp-img-gallery-wrapper");
  const buyNowButtonForMobile = document.querySelector(".buyNow-buy-now-mobile");
  const fixedBannerButton = document.querySelector(".fixed-banner-btn");
  
  
  
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && window.innerWidth < 768) {
          
          buyNowButtonForMobile.style.display = "block";          
          fixedBannerButton.style.display = "flex";  
          
        } else {
          
          buyNowButtonForMobile.style.display = "none";
          
        }
      });
    },
    { threshold: 0 }
  );
  
  // Observer'ı banner elementine bağla
  observer.observe(bottomDivider);
  
  // Pencere boyutu değiştiğinde kontrol et
  window.addEventListener("resize", () => {
    if (!observer) return;
    if (window.innerWidth < 768) {
      observer.observe(bottomDivider);
    } else {
      observer.unobserve(bottomDivider);
      buyNowButtonForMobile.style.display = "none";
    }
  });
  
  // ------------------------

  // tavk.to app
  if (window.innerWidth < 1000) styleTawkFunc();
  
  function styleTawkFunc() {
    const tawkWidgetInterval = setInterval(getTawkWidgetInterval, 1000);
    const clearTawkInterval = setInterval(clearTawkWidgetInterval, 10000);
  
    function getTawkWidgetInterval() {
      // console.log("tawk func run")
      let tawkWidgetVisibleIframe = document.querySelector(".richpanel-micro");
  
      if (tawkWidgetVisibleIframe) {
        // console.log("tawkWidgetVisibleIframe.classList.contains('rp-micro-app-hide')",tawkWidgetVisibleIframe.classList.contains('rp-micro-app-hide'))
        if (!tawkWidgetVisibleIframe.classList.contains("rp-micro-app-hide")) {
          fixedBannerButton.style.justifyContent = "left";
          document.querySelector(".fixed-banner-btn button").style.width = "70%";
          document.querySelector(".fixed-banner-btn button").style.fontSize = "22px";
          // console.log("tawk render edildi ve interval del");
          clearInterval(tawkWidgetInterval);
        }
      }
    }
  
    function clearTawkWidgetInterval() {
      clearInterval(tawkWidgetInterval);
      clearInterval(clearTawkInterval);
      // console.log("tawk render edilmedi 10 sn sonra interval del")
    }
  }


  // fixed btn events
  function customSmoothScroll(x) {
    window.scrollTo({
      top: x,
      behavior: "smooth",
    });
  }
  
  const xdBannerDropdownOpenId = document.querySelector("#xdBannerDropdownOpenId");
  const ppImgGalleryContent = document.querySelector(".pp-img-gallery-content");
  
  const shopNowButton = document.querySelector(".shop-now-button");
  function ddActions() {
    if(shopNowButton){ shopNowButton.style.display = "none"; }    
     
     if (window.innerWidth < 768) {
      if(ppImgGalleryContent) {
        const elementTop = ppImgGalleryContent.getBoundingClientRect().top + window.scrollY;
        customSmoothScroll(elementTop-85);        
      } else {      
        customSmoothScroll(855);  
      }
     } 
    
  }
  
  xdBannerDropdownOpenId.addEventListener("click", ddActions);
  
  if(shopNowButton){
    shopNowButton.addEventListener("click", () => {
      ddActions();
      
      if (window.innerWidth > 768) {
        if(ppImgGalleryContent) {
          const elementTop = ppImgGalleryContent.getBoundingClientRect().top + window.scrollY;
          customSmoothScroll(elementTop-85);   
        } else {      
          customSmoothScroll(460);   
        }        
      }
      
    });
  }
  // fixed btn events

  // TRC variant add to cart start
  const trcVariantAddToCartBtns = document.querySelectorAll(".pp-img-gallery--variants-wrapper .trc-each-variant-btn-with-add-to-cart");
  const trcVariantSelectionReset = document.querySelector(".trc-variant-selection-reset");  
  const visibleAfterSelection = document.querySelector(".visible-after-selection");

  if (trcVariantAddToCartBtns && trcVariantAddToCartBtns.length > 0) {
    // console.log("trcVariantAddToCartBtns --->", trcVariantAddToCartBtns);

    trcVariantAddToCartBtns.forEach(item => {
      item.addEventListener("click", (e) => {

        trcVariantAddToCartBtns.forEach(item => {
          item.style.display = "none";
          item.style.pointerEvents = "none";
        });
        
        item.style.display = "block";            
        item.querySelector(".btn-check-mark").style.display = "block";    
        trcVariantSelectionReset.style.display = "block";                

        const addToCartDataBtn = item.querySelector(".product__add-to-cart-button");
        const addToCartBtnSelf = document.querySelector(".pcfit__add");
        const addToCartByAntiTheft = document.querySelector(".pcfit__add--antitheft");

        addToCartBtnSelf.style.display = "block"; 
        visibleAfterSelection.style.display = "flex";
        
        addToCartBtnSelf.dataset.variantId = addToCartDataBtn.dataset.atc;
        addToCartByAntiTheft.dataset.variantId = addToCartDataBtn.dataset.atc;

        let selectionPropsParse = addToCartDataBtn.dataset.selection.split("/");
        const props = {
          Make: selectionPropsParse[1].trim() || "",
          Model: selectionPropsParse[2].trim() || "",
          Body: selectionPropsParse[3].trim() || "",
          Engine: selectionPropsParse[4].trim() || "",
        };
        addToCartBtnSelf.dataset.properties = JSON.stringify(props);
        addToCartByAntiTheft.dataset.properties = JSON.stringify(props); 

      });
    });

    // Eğer buton sayısı tam olarak 1 ise otomatik click tetikle
    if (trcVariantAddToCartBtns.length === 1) {
      trcVariantAddToCartBtns[0].click();
      trcVariantSelectionReset.style.display = "none";
    }
  }

  /* listen drawer open */
  const customDrawerIn = document.querySelector('.cst__panel');    
  function loadingHandle(button) {

    const observer = new MutationObserver(() => {
      if (customDrawerIn.style.transform === 'none') {
        loadingSpinner.classList.add('hidden');
        atcText.classList.remove('hidden');
        observer.disconnect();
      }
    });
  
    observer.observe(customDrawerIn, { attributes: true, attributeFilter: ['style'] });
  }
  /* listen drawer open */

  if (trcVariantAddToCartBtns) {    
    trcVariantAddToCartBtns.forEach(item => {
      let trcVariantAddToCartStyle = document.querySelector(".pcfit__add");
      trcVariantAddToCartStyle.addEventListener("click",(e) => {
        let targetParentEl = e.target.closest(".pcfit__add")
        loadingHandle(targetParentEl)
      })
    })
  }

  if(trcVariantSelectionReset) {
    trcVariantSelectionReset.addEventListener("click", () => {
      trcVariantSelectionReset.style.display = "none";
      if (trcVariantAddToCartBtns) {
         trcVariantAddToCartBtns.forEach(item => {            
           
           item.style.pointerEvents = "auto";
           item.style.display = "block";
           item.querySelector(".btn-check-mark").style.display = "none";

           // visible after selection
           const visibleAddToCart = visibleAfterSelection.querySelector(".pcfit__add");        
           visibleAddToCart.dataset.atc = "true";
           visibleAddToCart.dataset.selection = "";
           visibleAddToCart.dataset.variantId = "";
           visibleAfterSelection.style.display = "none";                                          
           
         });
      }
    })
  }


  



  // TRC variant add to cart end
  
  // ----------- Fixed btn & Variant add to cart -------------
  
});


